import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-bag-filler-a-pro',
  templateUrl: './bulk-bag-filler-a-pro.component.html',
  styleUrls: ['./bulk-bag-filler-a-pro.component.css']
})
export class BulkBagFillerAProComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
